import { BaseApiClient } from '../../../lib/api/BaseApiClient';
import { buildFingerprint } from '../../../lib/device/fingerprint';

// ProfileApi — talks to the /Profile resource on the CityCraft API.
// Maps to the "Profile" folder of the CC_Customer Postman collection.
// Response envelopes ({ responseStatus, result }) are unwrapped by BaseApiClient.
class ProfileApi extends BaseApiClient {
  constructor() {
    super('Profile');
  }

  // GET /Profile/GetUserProfile -> user profile object
  // NB: calls super.get() so this override does not recurse into itself.
  get() {
    return super.get('/GetUserProfile');
  }

  // POST /Profile/UpdateUserProfile
  update({ name, mobile, email }) {
    return super.post('/UpdateUserProfile', {
      name,
      mobile,
      email,
      otpCode: '',
      autoFillKey: '',
      fingerprint: buildFingerprint(),
    });
  }

  // POST /Profile/DeactivateAccount
  deactivate() {
    return this.post('/DeactivateAccount');
  }
}

export const profileApi = new ProfileApi();
export default profileApi;
